module.exports = __webpack_public_path__ + "img/M2.775fd663.jpg";